import { ActionButtonProps } from "./types";

export default function ActionButton({
	icon,
	text,
	onClick
}: ActionButtonProps) {
	return (
		<button
			type="button"
			className="button w-fit flex text-primary-700 border-none gap-2 items-center"
			onClick={onClick}
		>
			{icon} {text}
		</button>
	);
}
